import React, {Component} from 'react'
import configureStore from './store/configureStore'
import Root from './containers/Root'

import 'font-awesome/css/font-awesome.css'
import './favicon.ico'
import 'typeface-roboto'
import './index.scss'

export default class Web extends Component {
    render(){
        return <Root store={ configureStore() }/>
    }
}
